export const serializeCookieValue = <T extends object>(data: T): string => {
  return Object.entries(data)
    .reduce<string[]>((acc, [key, value]) => {
      if (value !== undefined) {
        acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(value))}`);
      }

      return acc;
    }, [])
    .join('&');
};

export const parseCookieValue = <T>(cookieValue: string): T => {
  const parsedData = {} as T;

  if (!cookieValue) {
    return parsedData;
  }

  cookieValue.split('&').forEach(item => {
    if (!item) {
      return;
    }

    const separatorIndex = item.indexOf('=');
    if (separatorIndex === -1) {
      return;
    }

    const rawKey = item.slice(0, separatorIndex);
    const rawValue = item.slice(separatorIndex + 1);
    const key = decodeURIComponent(rawKey) as keyof T;

    try {
      parsedData[key] = JSON.parse(decodeURIComponent(rawValue)) as T[keyof T];
    } catch {
      // Ignore malformed key-value pairs
    }
  });

  return parsedData;
};
